export default "__VITE_ASSET__BubWt256__"